import { useSelector } from "react-redux";
import en from "../../util/locales/en";
import ar from "../../util/locales/ar";
import styled from "styled-components";
import ValueCard from "./components/ValueCard";
import Container from "../common/Container";

const UniquePoints = () => {
  const language = useSelector((state) => state.language);
  const t = language === "en" ? en : ar;

  return (
    <Section>
      <Container>
        <Content>
          <h2>{t.about.unique.title}</h2>
          <CardsWrapper>
            <ValueCard
              title={t.about.unique.card1.title}
              description={t.about.unique.card1.text}
            />
            <ValueCard
              title={t.about.unique.card2.title}
              description={t.about.unique.card3.text}
            />
            <ValueCard
              title={t.about.unique.card3.title}
              description={t.about.unique.card3.text}
            />
          </CardsWrapper>
        </Content>
      </Container>

      <BottomShadow />
    </Section>
  );
};

export default UniquePoints;

const Section = styled.section`
  position: relative;
  background-image: url("/imgs/about-selling.jpg");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  padding: 3rem 0;
  overflow: hidden;
  filter: grayscale(1);
`;

const Content = styled.div`
  position: relative;
  z-index: 2;

  h2 {
    font-size: 2rem;
    font-weight: 700;
    margin-bottom: 2rem;
    color: #1a1a1a;
  }
`;

const CardsWrapper = styled.div`
  display: flex;
  gap: 1.5rem;
  justify-content: flex-start;

  @media (max-width: 768px) {
    overflow-x: auto;
    scroll-snap-type: x mandatory;
    -ms-overflow-style: none;
    scrollbar-width: none;
    -webkit-overflow-scrolling: touch;
  }
`;

const BottomShadow = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 450px;
  background: linear-gradient(
    to top,
    rgba(255, 255, 255, 0.8),
    rgba(255, 255, 255, 0.3),
    transparent
  );
  pointer-events: none;
  z-index: 1;
`;
